import { RefObject, useEffect } from "react";

const useOutsideClick = (
  ref: RefObject<HTMLElement>,
  callback: () => void,
  ref2: RefObject<HTMLElement>
): void => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        if (ref2?.current && ref2.current.contains(event.target as Node)) {
          return;
        }
        callback();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return (): void => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, callback, ref2]);
};

export default useOutsideClick;
